import { Head, Link, usePage } from "@inertiajs/react";
import { Check, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import MarketingLayout from "@/components/marketing/MarketingLayout";

export default function Thanks({ school_name, email }) {
  const { routes } = usePage().props;

  return (
    <MarketingLayout>
      <Head title="Thanks for signing up" />

      <section className="section-py">
        <div className="container max-w-xl">
          <Card>
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-success/15 border-2 border-success/30 flex items-center justify-center text-success">
                <Check className="h-7 w-7" strokeWidth={2.5} />
              </div>
              <Badge variant="success" className="mx-auto mb-2 w-fit">Account created</Badge>
              <h1 className="text-2xl md:text-3xl font-semibold leading-tight">
                {school_name ? `Thanks for signing up ${school_name}.` : "Thanks for signing up."}
              </h1>
              <CardDescription className="text-base leading-relaxed">
                {email ? <>We’ve sent a welcome email with your sign-in link to <strong>{email}</strong>.</> : "We’ve sent you a welcome email with your sign-in link."} Look for “Welcome to PagePledge” and click the link to start setting up your campaign. There’s no password to remember.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex gap-3 items-start rounded-lg border border-border bg-card p-4">
                <Mail className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <div className="text-sm text-muted-foreground leading-relaxed">
                  Your free trial has started. Set up classrooms, students, rewards and take-home sheets to see how it works. To run your campaign (go live, take donations, add teachers and email families), pay the campaign fee by e-Transfer and we’ll approve it.
                </div>
              </div>
              <div className="flex flex-wrap gap-3">
                <Button variant="outline" asChild>
                  <Link href={routes.home}>
                    Back to home
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </MarketingLayout>
  );
}
